<!-- コード入力コンポーネント -->
<template>
  <div class="passcode__wrapper">
    <!-- クーポンコードを入力してください -->
    <p class="passcode__wrapper--title">クーポンコードを入力してください</p>

    <div class="passcode__form">
      <!-- 文字数制限はスペース4つ含めて19文字 -->
      <input
        type="text"
        class="coupon-input"
        v-model="inputtedCouponCode"
        maxlength="19"
      />

      <!-- スペース1つ含めて9桁未満ならdisable -->
      <ItemButton
        label="OK"
        actionType="btn-primary"
        style="margin-bottom: 50px"
        @clicked="clickedOk()"
        :disabled="inputtedCouponCode.length < 9"
      />

      <ItemButton
        label="トップへ"
        actionType="btn-primary"
        @clicked="returnNativeTopMenu()"
      />
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from "vue";
import { useVModel } from "vue-composable";

import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "TheCCInputForm",
  props: {
    propCode: {
      type: String,
    },
    onChanged: {
      type: Function,
      required: true,
    },
    clickedOk: {
      type: Function,
      required: true,
    }
  },
  setup(props) {
    const inputtedCouponCode = useVModel(props, "propCode")

    const returnNativeTopMenu = () =>{
      nativeHandlerService.returnNativeTopMenu();
    }

    watch(
      () => inputtedCouponCode.value,
      (code) => props.onChanged(code),
    );

    return {
      inputtedCouponCode,
      returnNativeTopMenu,
    }
  }
};
</script>

<style lang="scss" scoped>
.passcode__wrapper {
  width: 300px;
  margin: auto;
  color: black;
  top: var(--navigation-height);
  position: relative;

  .passcode__wrapper--title {
    text-align: center;
    padding: 0;
    margin-bottom: 30px;
    font-size: 14px;
  }

  .passcode__form {
    position: relative;
    width: 100%;
  }

  .coupon-input {
    background: white;
    width: 100%;
    height: 50px;
    font-size: 23px;
    color: black;
    padding: 0;
    position: relative;
    text-align: center;
    text-transform: uppercase;
    margin-bottom: 50px;
    border: 1px solid;
    border-radius: 5px;
  }
}
</style>
